<script>
import StatsDataService from "@/services/StatsDataService";

export default {
  name: "ChartUsersRegister",
  data() {
    return {
      series:[],
      chartOptions: {
        chart: {
          id: 'users-register-gender',
          type: 'area',
          height: 350,
          zoom: {
            autoScaleYaxis: true
          },
          toolbar: {
            show: true,
            offsetX: 0,
            offsetY: 0,
            tools: {
              download: false,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: false,
              reset: true
            }
          }
        },
        colors: ['#77B6EA', '#f06292'],
        dataLabels: {
          enabled: false
        },
        xaxis: {
          type: 'datetime',
          labels: {
            show: true,
            style: {
              fontSize: 0
            },
            hideOverlappingLabels: true
          }
        },
        stroke: {
          curve: 'smooth',
          width: 1
        },
        noData: {
          text: 'Loading...'
        }
      },
      filtersDates: {
        selected: '1M',
        options: [
          {value:'1W', text:'1W'},
          {value:'1M', text:'1M'},
          {value:'3M', text:'3M'},
          {value:'6M', text:'6M'},
          {value:'1Y', text:'1Y'},
          {value:'ALL', text:'ALL'},
        ]
      }
    }
  },
  methods: {
    handleDateChange() {
      this.loadData();
    },

    loadData() {
      const params = {date: this.filtersDates.selected};
      StatsDataService.getUsersRegisterStats(params)
          .then(response => {
            const data = response.data;
            this.$refs.usersRegisterChart.updateSeries([{
              name: this.$t("male"),
              data: data.male
            },{
              name: this.$t("female"),
              data: data.female
            }]);
          })
          .catch(error => {
            window.console.error("StatsDataService.getUsersRegisterStats failed...", error);
          });
    }
  },
  mounted() {
    this.loadData();
  }
}
</script>

<template>
  <div class="card-body" id="cardChartRegister">
      <h5 class="card-title">Register per Day</h5>
      <b-form-radio-group
          v-model="filtersDates.selected"
          :options="filtersDates.options"
          button-variant="outline-secondary"
          size="sm"
          buttons
          class="mt-1 mb-2"
          @change="handleDateChange"
      ></b-form-radio-group>
    <apexchart
        ref="usersRegisterChart"
        type="area"
        dir="ltr"
        height="350"
        :series="series"
        :options="chartOptions"
    ></apexchart>
  </div>
</template>

<style>
#cardChartRegister .btn input[type=radio] {
  position: absolute;
  clip: rect(0,0,0,0);
  pointer-events: none;
}

#cardChartRegister .btn {
  margin-top: -8px;
  margin-bottom: 0 !important;
}
</style>